import {IDeepLinkActionsFactoryService} from './deep-link-actions-factory.service.inteface';
import {IDeepLinkAction} from '../deep-link-actions/deep-link-action.interface';
import {ServiceBase} from '../../ServiceBase';
import {CashierDeepLinkAction} from '../deep-link-actions/cashier/cashier-deeplink-action';
import {LoginDeepLinkAction} from '../deep-link-actions/login/login-deeplink-action';
import {PlayGameRealDeepLinkAction} from '../deep-link-actions/play-game/play-game-real/play-game-real-deeplink-action';
import {PlayGameDemoDeepLinkAction} from '../deep-link-actions/play-game/play-game-demo/play-game-demo-deeplink-action';
import {RegisterDeepLinkAction} from '../deep-link-actions/register/register-deeplink-action';
import {MyAccountDeepLinkAction} from '../deep-link-actions/my-account/my-account-deeplink-action';
import {RedirectDeepLinkAction} from '../deep-link-actions/redirect/redirect-deeplink-action';
import {TerminateDeepLinkAction} from '../deep-link-actions/terminate/terminate-deeplink-action';
import {UploadDocumentDeepLinkAction} from '../deep-link-actions/upload-document/upload-document-deeplink-action';
import {DeepLinkExecutionContext} from '../deep-link-actions/deep-link-execution-context.interface';
import {IDeepLinkActionChain} from '../deep-link-actions/deep-link-action-chain';
import {IDeepLinkParser} from '../deep-link-parsers/parsers/deep-link-parser.interface';
import {JackpotGamesDeeplinkAction} from "../deep-link-actions/jackpot-games/jackpot-games-deeplink-action";
import {FreePlayDeepLinkAction} from "../deep-link-actions/freeplay/freeplay-deeplink-action";
import { OpenListDeeplinkByIdAction, OpenListDeeplinkByTitleAction } from '../deep-link-actions/open-list/open-list-deeplink-action';
import { ControlCenterDeeplinkAction } from '../deep-link-actions/control-center/control-center-deeplink-action';

export class DeepLinkActionsFactoryService extends ServiceBase implements IDeepLinkActionsFactoryService {


  private _actionsPrototypes = {
    cashier: CashierDeepLinkAction,
    register: RegisterDeepLinkAction,
    login: LoginDeepLinkAction,
    my_account: MyAccountDeepLinkAction,
    'game-real': PlayGameRealDeepLinkAction,
    'game-demo': PlayGameDemoDeepLinkAction,
    redirect: RedirectDeepLinkAction,
    terminate: TerminateDeepLinkAction,
    'upload-document': UploadDocumentDeepLinkAction,
    'jackpot-games': JackpotGamesDeeplinkAction,
    'open-list': OpenListDeeplinkByTitleAction,
    'open-list-id': OpenListDeeplinkByIdAction,
    'freeplay': FreePlayDeepLinkAction,
    'control-center': ControlCenterDeeplinkAction
  };

  createActionFromCurrentRoute(): IDeepLinkAction | null {

    let parser = this.services.deepLinkParser.getParserFromCurrentRoute();

    if(parser) {
      return this._createActionsFromParser(parser);
    }

    return null;
  }


  isActionOfType(actionInstance: IDeepLinkAction, actionPrototype: any): boolean {
    return actionInstance instanceof actionPrototype;
  }


  createActionFromDeepLinkObject(deepLinkObject: any): IDeepLinkAction | null {
    let parser = this.services.deepLinkParser.getParserFromDeepLinkObject(deepLinkObject);
    if(parser) {
      return this._createActionsFromParser(parser);
    }

    return null;
  }

  private _createActionsFromParser(parser: IDeepLinkParser) : IDeepLinkAction | null {
    let actionsDescriptors = parser.getActionsDescriptors();
    let deepLinkBuilder = parser.getDeepLinkBuilder();

    let action: IDeepLinkActionChain | null = null;
    for(let i = actionsDescriptors.length -1; i >= 0; i--) {
      let actionDescriptor = actionsDescriptors[i];
      let actionPrototype = this._actionsPrototypes[actionDescriptor.action];
      if(actionPrototype) {
        let actionExecutionContext: DeepLinkExecutionContext = {
          services: this.services,
          deepLinkBuilder: deepLinkBuilder,
          nextAction: action,
          descriptor: actionDescriptor
        };

        action = new actionPrototype(actionExecutionContext) as IDeepLinkActionChain;
      } else {
        this.services.logger.error(`Can't handle deep link action '${actionDescriptor.action}'`);
        return null;
      }
    }

    return action;
  }

}
